/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 *
 * @export
 * @interface RiskIndicatorSummary
 */
export interface RiskIndicatorSummary {
  /**
   *
   * @type {number}
   * @memberof RiskIndicatorSummary
   */
  performanceScore: number | null;
  /**
   *
   * @type {number}
   * @memberof RiskIndicatorSummary
   */
  fairnessScore: number | null;
  /**
   *
   * @type {number}
   * @memberof RiskIndicatorSummary
   */
  robustnessScore: number | null;
  /**
   *
   * @type {number}
   * @memberof RiskIndicatorSummary
   */
  explainabilityScore: number | null;
}

/**
 * Check if a given object implements the RiskIndicatorSummary interface.
 */
export function instanceOfRiskIndicatorSummary(value: object): value is RiskIndicatorSummary {
  if (!('performanceScore' in value) || value['performanceScore'] === undefined) return false;
  if (!('fairnessScore' in value) || value['fairnessScore'] === undefined) return false;
  if (!('robustnessScore' in value) || value['robustnessScore'] === undefined) return false;
  if (!('explainabilityScore' in value) || value['explainabilityScore'] === undefined) return false;
  return true;
}

export function RiskIndicatorSummaryFromJSON(json: any): RiskIndicatorSummary {
  return RiskIndicatorSummaryFromJSONTyped(json, false);
}

export function RiskIndicatorSummaryFromJSONTyped(json: any, ignoreDiscriminator: boolean): RiskIndicatorSummary {
  if (json == null) {
    return json;
  }
  return {
    performanceScore: json['performance_score'],
    fairnessScore: json['fairness_score'],
    robustnessScore: json['robustness_score'],
    explainabilityScore: json['explainability_score'],
  };
}

export function RiskIndicatorSummaryToJSON(value?: RiskIndicatorSummary | null): any {
  if (value == null) {
    return value;
  }
  return {
    performance_score: value['performanceScore'],
    fairness_score: value['fairnessScore'],
    robustness_score: value['robustnessScore'],
    explainability_score: value['explainabilityScore'],
  };
}
